import { ReactElement } from 'react'
import { TooltipProps } from '@mui/material'
import { ToggleButton } from '@ui/actions'
import { Wall } from '@ui/icons'

interface Props {
  onClick: () => void
  value: boolean
  hint?: string
  tooltipPlacement?: TooltipProps['placement']
  'data-cy'?: string
}

const WallSelect = ({
  onClick,
  value,
  hint = '',
  tooltipPlacement = 'bottom',
  'data-cy': dataCy,
}: Props): ReactElement => {
  return (
    <ToggleButton
      hint={hint}
      tooltipPlacement={tooltipPlacement}
      value="snap"
      size="small"
      onClick={onClick}
      selected={value}
      Icon={Wall}
      data-cy={dataCy}
    />
  )
}

export default WallSelect
